import EmailSignInController from '../controllers/EmailSignInController.js';
import CreateAccountController from '../controllers/CreateAccountController.js';
import ResetPasswordController from '../controllers/ResetPasswordController.js';
import ActivationRequiredController from '../controllers/ActivationRequiredController.js';
import CardNumberSignInController from '../controllers/CardNumberSignInController.js';

class UserSignInTask {
    static run({env}) {
        if (!env.getInstitution().hasEmailAuthentication()) {
            CardNumberSignInController.create({env}).show();
            return;
        }

        EmailSignInController.create({env});
        CreateAccountController.create({env});
        ResetPasswordController.create({env});
        ActivationRequiredController.create({env});

        env.navTo('userSignIn');
    }
}

export default UserSignInTask;